import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from 'react';
import { MessageResource } from '@medable/i18n-core';
import { Locale } from './locales';
const DEFAULT_LOCALE = Locale.en_US;
const DEFAULT_MESSAGE_RESOURCE = new MessageResource(DEFAULT_LOCALE, {});
/** Provides to the current locale. */
export const LocaleContext = createContext(DEFAULT_LOCALE);
/** Allows to change the current locale. */
export const SetLocaleContext = createContext(null);
/** MessageResource for the curent locale. */
const MessageResourceContext = createContext(DEFAULT_MESSAGE_RESOURCE);
/** Provides a method to localize messages. */
export function useLocalizeMessage() {
    const messageResource = useContext(MessageResourceContext);
    return (source, params) => messageResource.resolve(source, params);
}
/** Provides I18n context fot localized UI. */
export const I18nContextProvider = ({ locale = DEFAULT_LOCALE, messageProvider = () => DEFAULT_MESSAGE_RESOURCE, children, }) => {
    const [currentLocale, setCurrentLocale] = useState(locale);
    const [messageResource, setMessageResource] = useState(messageProvider(locale));
    function updateLocale(newLocale) {
        const messageResource = messageProvider(newLocale);
        setCurrentLocale(newLocale);
        setMessageResource(messageResource);
    }
    return (_jsx(LocaleContext.Provider, { value: currentLocale, children: _jsx(SetLocaleContext.Provider, { value: (newLocale) => updateLocale(newLocale), children: _jsx(MessageResourceContext.Provider, { value: messageResource, children: children }) }) }));
};
//# sourceMappingURL=i18n_context.js.map